// Generated by ReScript, PLEASE EDIT WITH CARE


let Style = {};

function toPx(value) {
  return String(value) + "px";
}

export {
  Style,
  toPx,
}
/* No side effect */
